// extracted by mini-css-extract-plugin
export var numpadContainer = "_ke-1";
export var phoneButton = "_ke-0";